<template>
  <div class="bg-white tabs p-5 mb-3 border-shadow">
    <b-tabs
      v-model="active"
      active-nav-item-class="font-weight-bold"
      content-class="mt-4"
    >
      <b-tab
        v-for="menu in activeMenus"
        :title="menu.label"
        :key="menu.id"
        :disabled="menu.disabled"
        :title-link-class="linkClass(menu.id)"
      >
        <slot :name="menu.id" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    menus: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    activeMenus() {
      return this.menus.filter((menu) => !menu.hide);
    },
  },
  methods: {
    linkClass(idx) {
      if (this.active === idx) return ['color-default'];
      return ['text-muted'];
    },
  },
};
</script>
